// extracted by mini-css-extract-plugin
export var additionalSingleMovieHolder = "course-player-list-item-module--additional-single-movie-holder--27ce1";
export var clickable = "course-player-list-item-module--clickable--9c97c";
export var durationTime = "course-player-list-item-module--duration-time--2549b";
export var fakeWrapperIconLock = "course-player-list-item-module--fake-wrapper-icon-lock--2bbe4";
export var gatsbyImageWrapper = "course-player-list-item-module--gatsby-image-wrapper--4474d";
export var icon = "course-player-list-item-module--icon--1033e";
export var iconLock = "course-player-list-item-module--icon-lock--50a7a";
export var listItem = "course-player-list-item-module--list-item--9e588";
export var playIcon = "course-player-list-item-module--play-icon--ed0d7";
export var playerItemInfo = "course-player-list-item-module--player-item-info--201d8";
export var ratioClass = "course-player-list-item-module--ratio-class--7ae0e";
export var relative = "course-player-list-item-module--relative--5653a";
export var restrictedButton = "course-player-list-item-module--restricted-button--d7dd3";
export var time = "course-player-list-item-module--time--cf6fb";
export var title = "course-player-list-item-module--title--e84f5";